<!--
  作者：xiaoyu.li
  时间：2020年03月14日 15:24:46
-->
<template>
  <div>
    <div class="join_store">
      <div class="joins_title">
        <div class="name">
          <van-icon class="icon"
                    color="#FD9245"
                    size="22"
                    name="location" />参与门店 · {{totallist}}</div>
        <div class="more"
             @click="showPop=true"
             v-if="totallist>2">查看全部 ></div>
      </div>
      <div class="joins_list">
        <div v-for="(item, index) in storelist"
             :key="item.id">
          <div class="list_line"
               v-if="index <2">
            <div class="num_index">{{index +1}}</div>
            <div class="line_text van-hairline--bottom">{{item.storeName}}</div>
          </div>
        </div>
      </div>
    </div>
    <van-popup :show="showPop"
               :round="true"
               @close="showPop=false"
               close-icon="https://img.esenyun.com/images/20200315/db880a048c6e4985840f2f0e0b0698bc.png"
               closeable>
      <div style="width:310px;">
        <div class="pop_title">
          <div class="name">
            <van-icon class="icon"
                      color="#fff"
                      size="22"
                      name="location" />参与门店 · {{totallist}}</div>
        </div>
        <div class="pop_list">
          <div class="list_line"
               v-for="(item, index) in storelist"
               :key="item.id">
            <div class="num_index">{{index + 1}}</div>
            <div class="line_text van-hairline--bottom">{{item.storeName}}</div>
          </div>
        </div>
        <div class="pop_more"
             v-if="totallist>6">
          <span>查看更多</span>
          <img class="icon"
               src="../assets/down.svg"
               alt=""></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  // 组件名称
  name: 'JoinStore',
  // 组件参数 接收来自父组件的数据
  props: {
    activityId: {
      type: String,
      default: ''
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {
      moment:moment,
      showPop: false,  // 是否打开查看更多弹框
      storelist: [], // 门店列表
      totallist: 0 // 所有参与门店
    }
  },
  // 计算属性
  computed: {},
  mounted () {
    this.getStores()
  },
  // 组件方法
  methods: {
    // 获取门店列表
    getStores () {
      const params = {
        page: 0,
        size: 6
      }
      this.$http.get(`aocampaign/openapi/activity/store/list/${this.activityId}`, params).then((res) => {
        this.storelist = res.data.content
        this.totallist = res.data.totalElements
      })
    }
  },
}
</script> 

<style lang="less" scoped>
.join_store {
  padding: 0 16px;
  background-color: #fff;
}
.joins_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  .name {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    display: flex;
    align-items: center;
    .icon {
      margin-right: 3px;
    }
  }
  .more {
    font-size: 13px;
    line-height: 22px;
    color: #000000;
    opacity: 0.6;
  }
}
.list_line {
  display: flex;
  align-items: center;
  .num_index {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    font-size: 9px;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #dd782f;
    background: rgba(221, 120, 47, 0.1);
    border-radius: 100%;
  }
  .line_text {
    margin-left: 6px;
    height: 50px;
    line-height: 50px;
    font-weight: 500;
    font-size: 13px;
    color: #571910;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    white-space: nowrap;
  }
}
.pop_title {
  background: #fd9245;
  font-weight: 500;
  font-size: 20px;
  color: #fff;
  height: 58px;
  display: flex;
  align-items: center;
  padding: 0 18px;
  .name {
    font-weight: 500;
    font-size: 16px;
    color: #fff;
    display: flex;
    align-items: center;
    .icon {
      margin-right: 3px;
    }
  }
}
.pop_list {
  padding: 0 8px;
}
.pop_more {
  color: rgba(166, 166, 166, 0.98);
  font-size: 11px;
  line-height: 24px;
  display: flex;
  height: 46px;
  align-items: center;
  justify-content: center;
  .icon {
    width: 16px;
    height: 16px;
  }
}
/deep/.van-popup {
  border-radius: 8px;
}
</style>
